/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Pending_DescInputs */

const en_directory_submit_enrich_pending_desc = /** @type {(inputs: Directory_Submit_Enrich_Pending_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing is in the free review queue, and its link will be nofollow. Fast Track puts it live now with a dofollow link — no badge needed.`)
};

const zh_directory_submit_enrich_pending_desc = /** @type {(inputs: Directory_Submit_Enrich_Pending_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的条目已进入免费审核队列，外链为 nofollow。快速上线可立即发布并获得 dofollow 外链——无需挂徽章。`)
};

/**
* | output |
* | --- |
* | "Your listing is in the free review queue, and its link will be nofollow. Fast Track puts it live now with a dofollow link — no badge needed." |
*
* @param {Directory_Submit_Enrich_Pending_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_pending_desc = /** @type {((inputs?: Directory_Submit_Enrich_Pending_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Pending_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_pending_desc(inputs)
	return zh_directory_submit_enrich_pending_desc(inputs)
});
export { directory_submit_enrich_pending_desc as "directory.submit.enrich.pending_desc" }